import React, {useState, useEffect} from "react";
import {useFetch} from "../../../../components/common/FetchProvider";
import Loader from "components/Loader/Loader";
import InputField from "components/fields/InputField";
import ErrorModal from "../../reports/components/ErrorModal";
import {getDateRange} from "utils/utils"

const IncomeModal = ({
                         showModal,
                         setModalState,
                         refreshData,
                         organizationData,
                         organizationId,
                         accountId,
                         availableAccounts,
                         existingFormData,
                         setExistingFormData,
                         setIncomeConfirmModalState,
                         addPreviousMonthRecord
                     }) => {
    const fetchWrapper = useFetch();
    const [errorMessages, setErrorMessages] = useState({});
    const [loading, setLoading] = useState(false);
    const [natures, setNatures] = useState(null);
    const [isChecked, setIsChecked] = useState(false);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const handleCheckboxChange = (event) => {
        setIsChecked(event.target.checked);
    };

    const [formData, setFormData] = React.useState({
        organizationId: organizationId,
        accountId: accountId,
    });


    const [formErrorData, setFormErrorData] = useState({});
    const handleInputChange = (event) => {
        errorMessages.message = "";
        setFormErrorData({});
        const {id, value} = event.target;
        setFormData((prevState) => ({
            ...prevState,
            [id]: value,
        }));
    };

    const updateFormData = (id, value) => {
        setFormData((prevState) => ({
            ...prevState,
            [id]: value,
        }));
    }

    const setErrorForField = (field) => {
        setFormErrorData({[field]: "error"});
    }

    const [minDate, setMinDate] = useState("");
    const [maxDate, setMaxDate] = useState("");

    useEffect(() => {
        const { minDate, maxDate } = getDateRange(addPreviousMonthRecord);
        setMinDate(minDate);
        setMaxDate(maxDate);
    }, [addPreviousMonthRecord]);

    const errors = {
        organizationId: "Please select Orgão",
        description: "Please enter Descrição",
        seqNumber: "Please enter valid N.Doc",
        beneficiary: "Please enter valid Beneficiário",
        receivedDate: "Please enter valid Data recebimento",
        natureId: "Please select Nat. Receita",
        amount: "Please enter valid Valor",
        accountId: "Please select N conta/Moeda",
        apiError: "Something went wrong"
    };

    const validationRules = {
        organizationId: {
            validate: (value) => value !== undefined && value !== "",
            message: errors.organizationId,
        },
        description: {
            validate: (value) => value && value.length >= 5,
            message: errors.description,
        },
        seqNumber: {
            validate: (value) => value && value.length >= 3,
            message: errors.seqNumber,
        },
        beneficiary: {
            validate: (value) => value && value.length >= 3,
            message: errors.beneficiary,
        },
        receivedDate: {
            validate: (value) => value !== undefined && value !== "",
            message: errors.receivedDate,
        },
        natureId: {
            validate: (value) => value !== undefined && value !== "",
            message: errors.natureId,
        },
        amount: {
            validate: (value) => value !== undefined && value !== "",
            message: errors.amount,
        },
        accountId: {
            validate: (value) => value !== undefined && value !== "",
            message: errors.accountId,
        },
    };

    useEffect(() => {
        fetchDropdownValues();
        setExistingData(existingFormData);
        if (showModal) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
        return () => {
            document.body.style.overflow = "auto";
        };
    }, [showModal]);

    const setExistingData = (data) => {
        if (data !== null && data !== undefined && data.id != null) {
            setFormData(data)
        }
    }

    const handleCancel = () => {
        setExistingFormData(null);
        setModalState(false);
    }

    const fetchDropdownValues = async () => {
        setLoading(true);
        try {
            let apiUrl = `${process.env.REACT_APP_API_URL}/v1/financial-management/recita/dropdown?organizationId=${organizationId}`;
            const userToken = localStorage.getItem("token");
            const response = await fetchWrapper(apiUrl, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${userToken}`,
                },
            });
            setLoading(false);
            if (response.ok) {
                const responseData = await response.json();
                if (responseData.data) {
                    setNatures(responseData.data.natures);
                    if (!existingFormData || !existingFormData.seqNumber) {
                        updateFormData('seqNumber', responseData.data.seqNumber);
                    }

                }
            }
        } catch (error) {
            setLoading(false);
            if (error.body && error.body.responseInfo) {
                setErrorMessage(error.body.responseInfo.message);
                setShowErrorModal(true);
            } else {
                console.error("Error: Unable to handle ", error);
                setErrorMessage("Ocorreu um erro inesperado");
                setShowErrorModal(true);
            }
        }
    };

    const handleSubmit = async () => {
        for (let field in validationRules) {
            const {validate, message} = validationRules[field];
            if (!validate(formData[field])) {
                setErrorMessages({name: field, message: message});
                setErrorForField(field);
                return;
            }
        }

        setLoading(true);
        try {
            const requestOptions = {
                method: existingFormData != null && existingFormData.id !== undefined ? "PUT" : "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem("token")
                },
                body: JSON.stringify({...formData, sigfe: isChecked})
            };
            let apiUrl = `${process.env.REACT_APP_API_URL}/v1/financial-management/recita`;
            const response = await fetchWrapper(apiUrl, requestOptions);
            setLoading(false);
            if (response.ok) {
                const responseBody = await response.json();
                refreshData();
                setExistingFormData({id: responseBody.data.id});
                setIncomeConfirmModalState(true);
                setModalState(false);
            }
        } catch (error) {
            setLoading(false);
            if (error.body && error.body.responseInfo) {
                setErrorMessage(error.body.responseInfo.message);
                setShowErrorModal(true);
            } else {
                console.error("Error: Unable to handle ", error);
                setErrorMessage("Ocorreu um erro inesperado");
                setShowErrorModal(true);
            }
        }
    };

    const updateDescription = async () => {
        setLoading(true);
        try {
            const requestOptions = {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem("token")
                },
                body: JSON.stringify({
                    id: existingFormData.id,
                    description: formData.description,
                    beneficiary: formData.beneficiary
                })
            };
            let apiUrl = `${process.env.REACT_APP_API_URL}/v1/financial-management/recita/description`;
            const response = await fetchWrapper(apiUrl, requestOptions);
            setLoading(false);
            if (response.ok) {
                const responseBody = await response.json();
                refreshData();
                setExistingFormData({id: responseBody.data.id});
                setIncomeConfirmModalState(true);
                setModalState(false);
            }
        } catch (error) {
            setLoading(false);
            if (error.body && error.body.responseInfo) {
                setErrorMessage(error.body.responseInfo.message);
                setShowErrorModal(true);
            } else {
                console.error("Error: Unable to handle ", error);
                setErrorMessage("Ocorreu um erro inesperado");
                setShowErrorModal(true);
            }
        }
    }

    return (
        <>
            {showErrorModal &&
                <ErrorModal
                    showErrorModal={showErrorModal}
                    setShowErrorModal={setShowErrorModal}
                    errorMessage={errorMessage}
                />
            }
            {showModal && !showErrorModal ? (
                <>
                    <Loader show={loading}/>
                    <div
                        className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden outline-none focus:outline-none">
                        <div className="relative my-10 mx-auto w-full max-w-3xl sm:w-4/5 md:w-3/4 lg:w-2/3 xl:w-1/2">
                            <div
                                className="relative font-normal flex flex-col rounded-lg border-0 bg-white text-navy-800 shadow-lg outline-none focus:outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white dark:shadow-none">

                                {/* Modal Header */}
                                <div
                                    className="flex items-start justify-between rounded-t border-b border-solid p-5 border-slate-200">
                                    <h4 className="text-3xl font-semibold">Cadastrar Recita</h4>
                                </div>

                                {/* Modal Body */}
                                <div className="p-5 space-y-4" style={{overflowY: "auto", maxHeight: "70vh"}}>
                                    <div className="text-red-500 min-h-[1.30rem]">{errorMessages.message}</div>


                                    <div className="flex space-x-6 items-center">
                                        {/* Orgão Field */}
                                        <div className="flex flex-col w-full">
                                            <label className="text-sm dark:text-white ml-1.5 font-medium">Orgão</label>
                                            <select
                                                className={`mt-1 h-12 w-full rounded-xl border bg-gray-200 text-gray-500 p-3 text-sm outline-none cursor-not-allowed dark:!border-white/10`}
                                                id="organizationId"
                                                value={formData.organizationId}
                                                disabled
                                            >
                                                <option value="">Selecione órgão</option>
                                                {organizationData && organizationData.map((organization) => (
                                                    <option key={organization.id} value={organization.id}>
                                                        {organization.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>


                                    <InputField
                                        variant="auth"
                                        extra="w-full mb-3"
                                        label="Descrição"
                                        placeholder="Descrição"
                                        id="description"
                                        type="text"
                                        state={formErrorData.description === "error" ? "error" : ""}
                                        value={formData.description}
                                        onChange={handleInputChange}
                                    />

                                    {/* Row 1: Payment Date with Calendar Icon and Document Number */}
                                    <div className="flex space-x-4 items-start">
                                        {/* Payment Date Field */}
                                        <div className="w-full">
                                            <div className="relative">
                                                <InputField
                                                    variant="auth"
                                                    label="N.Doc"
                                                    id="seqNumber"
                                                    type="text"
                                                    state={formErrorData.seqNumber === "error" ? "error" : ""}
                                                    value={formData.seqNumber}
                                                    onChange={handleInputChange}
                                                    disabled
                                                />
                                            </div>
                                        </div>

                                        {/* Document Number Field */}
                                        <div className="w-full">
                                            <InputField
                                                extra="text-navy-800"
                                                variant="auth"
                                                label="Beneficiário"
                                                id="beneficiary"
                                                type="text"
                                                state={formErrorData.beneficiary === "error" ? "error" : ""}
                                                value={formData.beneficiary}
                                                onChange={handleInputChange}
                                            />

                                        </div>
                                    </div>

                                    <div className="flex space-x-4 items-start">
                                        {/* Fatura Number Field */}
                                        <div className="w-full">
                                            <InputField
                                                variant="auth"
                                                label="Data recebimento"
                                                placeholder="Data recebimento"
                                                id="receivedDate"
                                                type="date"
                                                state={formErrorData.receivedDate === "error" ? "error" : ""}
                                                value={formData.receivedDate}
                                                onChange={handleInputChange}
                                                disabled={existingFormData && existingFormData.disabledView}
                                                min={minDate}
                                                max={maxDate}
                                            />
                                        </div>

                                        {/* Beneficiary Field */}
                                        <div className="w-full">
                                            <label
                                                className="text-sm  dark:text-white ml-1.5 font-medium">Nat.
                                                Receita</label>
                                            <select
                                                className={`mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none dark:!border-white/10  ${formErrorData.natureId === "error" ? "border-red-500" : ""
                                                }`}
                                                id="natureId"
                                                value={formData.natureId}
                                                onChange={handleInputChange}
                                                disabled={existingFormData && existingFormData.disabledView}
                                            >
                                                <option value="">Selecione nat de despesa</option>
                                                {natures && natures.map((nature) => (
                                                    <option key={nature.id} value={nature.id}>
                                                        {nature.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>


                                    <div className="flex space-x-4 items-start">

                                        <div className="w-1/2">
                                            <InputField
                                                variant="auth"
                                                label="Valor"
                                                placeholder="Valor"
                                                id="amount"
                                                type="number"
                                                state={formErrorData.amount === "error" ? "error" : ""}
                                                value={formData.amount}
                                                onChange={handleInputChange}
                                                disabled={existingFormData && existingFormData.disabledView}
                                            />
                                        </div>
                                        {/* First Dropdown Field */}
                                        <div className="w-1/2">
                                            <label className="text-sm  dark:text-white ml-1.5 font-medium">N
                                                conta/Moeda</label>
                                            <select
                                                className={`mt-1 h-12 w-full rounded-xl border bg-gray-200 text-gray-500 p-3 text-sm outline-none cursor-not-allowed dark:!border-white/10`}
                                                id="accountId"
                                                value={formData.accountId}
                                                onChange={handleInputChange}
                                                disabled
                                            >
                                                <option value="">Selecione N conta/Moeda</option>
                                                {availableAccounts && availableAccounts.map((accounts) => (
                                                    <option key={accounts.id} value={accounts.id}>
                                                        {accounts.accountNumber ? accounts.accountNumber : accounts.accountName} - {accounts.accountCurrency}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                    </div>
                                    <div className="mt-3 flex items-center gap-3">
                                        <label
                                            className="text-sm  dark:text-white ml-1.5 font-medium">Lançar no
                                            SIGFE</label>
                                        <input
                                            className="defaultCheckbox relative flex h-[20px] min-h-[20px] w-[20px] min-w-[20px] appearance-none items-center
      justify-center rounded-md border border-gray-300 text-white/0 outline-none transition duration-[0.2s]
      checked:border-none checked:text-white hover:cursor-pointer dark:border-white/10 checked:bg-brand-500 dark:checked:bg-brand-400"
                                            type="checkbox"
                                            checked={isChecked}
                                            onChange={handleCheckboxChange}
                                            disabled={existingFormData && existingFormData.disabledView}
                                        />

                                    </div>


                                </div>

                                {/* Modal Footer */}
                                <div
                                    className="flex items-center justify-end p-5 border-t border-solid border-slate-200 rounded-b">
                                    <button
                                        onClick={handleCancel}
                                        className="linear mt-2 w-48 rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200">
                                        Cancelar
                                    </button>
                                    {
                                        (existingFormData && existingFormData.disabledView) ?
                                            (
                                                <button
                                                    onClick={updateDescription}
                                                    className={`linear mt-2 w-48 rounded-xl py-[12px] text-base font-medium text-white transition duration-200 ml-auto
                                                    bg-brand-500 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:bg-brand-200"`}
                                                >
                                                    Descrição da atualização
                                                </button>
                                            ) :
                                            (
                                                <button
                                                    onClick={handleSubmit}
                                                    disabled={existingFormData && existingFormData.disabledView}
                                                    className={`linear mt-2 w-48 rounded-xl py-[12px] text-base font-medium text-white transition duration-200 ml-auto
                                                    ${existingFormData && existingFormData.disabledView ? "bg-brand-400 cursor-not-allowed" : "bg-brand-500 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:bg-brand-200"}`}
                                                >
                                                    Registrar
                                                </button>
                                            )
                                    }
                                </div>
                            </div>
                        </div>

                    </div>


                    {/*overlay*/}
                    <div className="bg-black opacity-90 fixed inset-0 z-40 backdrop-blur-2xl backdrop-filter"></div>
                </>
            ) : null}
        </>
    );
};

export default IncomeModal;
